import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DefinitionList from '../DefinitionList';
import DataDefinition from '../../atoms/list/DataDefinition';
import styled from 'styled-components';
import AuthLink from '../../atoms/AuthLink';
import { useTranslation } from 'react-i18next';
const StyledAuthLink = styled(AuthLink) `
    margin-top: 0;
    color: ${props => props.theme.secondary};
    font-weight: 500;

    &:before {
        background-color: ${props => props.theme.secondary};
        width: 100%;
    }
`;
const OtherDossiers = ({ dossier }) => {
    const { t } = useTranslation();
    const openDossierCount = dossier.other_open_dossiers_count || 0;
    const closedDossierCount = dossier.other_closed_dossiers_count || 0;
    return (_jsxs(_Fragment, { children: [(openDossierCount > 0 || closedDossierCount > 0) && (_jsx(DefinitionList, { children: _jsx(DataDefinition, { children: _jsx(StyledAuthLink, { href: `/dossiers?reference=${dossier.reference.split('/').shift()}&status=null`, children: t('sidebar.other_dossiers.all_dossiers', {
                            amount: openDossierCount + closedDossierCount + 1,
                        }) }) }) })), openDossierCount > 0 && (_jsx(DefinitionList, { children: _jsx(DataDefinition, { children: _jsx(StyledAuthLink, { href: `/dossiers?reference=${dossier.reference.split('/').shift()}&status=open`, children: t('sidebar.other_dossiers.ongoing_dossiers', {
                            amount: !dossier.closed_at
                                ? openDossierCount + 1
                                : openDossierCount,
                        }) }) }) })), closedDossierCount > 0 && (_jsx(DefinitionList, { children: _jsx(DataDefinition, { children: _jsx(StyledAuthLink, { href: `/dossiers?reference=${dossier.reference.split('/').shift()}&status=closed`, children: t('sidebar.other_dossiers.closed_dossiers', {
                            amount: dossier.closed_at
                                ? closedDossierCount + 1
                                : closedDossierCount,
                        }) }) }) }))] }));
};
export default OtherDossiers;
